export const Verse = {
  bgDark: '#030C14',
  bgInput: '#101624',
  border: '#1E2A31',
  borderLight: '#2B424F',
  alertBlue: '#022543',
  darkBlue: '#001C36',
  fadedBlue: '#4e6274',
  verseBlue: '#0085FF',
  midGray: '#8D8D8D',
  darkGray: '#252D40',
  alertYellow: '#4a3813',
  glow: '0px 4px 120px 0px rgba(47, 169, 238, 0.4)',
  glowLight: 'rgba(47, 169, 238, 0.2) 0px 2px 60px 0px;',
};
